// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconBell = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      d="M14.463 21.97a2.85 2.85 0 01-2.72 2.04 2.85 2.85 0 01-2.72-2.04c-.12-.4.11-.81.51-.93s.81.11.93.51c.17.57.69.96 1.28.96.59 0 1.12-.39 1.28-.96.12-.4.53-.62.93-.51.4.11.63.53.51.93zm6.99-2.97c-.11.3-.39.5-.71.5h-18a.73.73 0 01-.67-.42.776.776 0 01.08-.79c.01-.01 1.34-1.9 1.34-7.79 0-4.3 3.3-7.83 7.5-8.21V.75c0-.41.34-.75.75-.75s.75.34.75.75v1.54c4.2.38 7.5 3.92 7.5 8.21 0 6.29 1.21 7.66 1.22 7.67.25.2.34.53.24.83zm-2-1c-.47-1.21-.96-3.45-.96-7.5 0-3.72-3.03-6.75-6.75-6.75s-6.75 3.03-6.75 6.75c0 3.95-.57 6.26-1.04 7.5h15.5z"
      fill="currentColor"
    />
  );
export default SvgIconBell;
